import React from 'react';
import './Error.css';
 
const Error = () => {
    return (
       <div className="error">
          <p>Error: Page does not exist!</p>
       </div>
    );
}
 
export default Error;